import {alpha, createTheme, ThemeOptions} from '@mui/material';

const originalTheme = createTheme();

const notredameSaudeStyles: ThemeOptions = {
	name: 'notredame',
	colors: {
		brand: {
			primary: {
				blue: '#001453',
				white: '#FFFFFF',
				orange: '#FF4E05',
				yellow: '#FFCC00',
				lightOrange: '#FF8800',
				reddishOrange: '#FF222B',
			},
			secondary: {
				wheat: '#DED6C9',
				leadGray: '#3C3C3C',
				lightGray: '#585757',
				terracota: '#E8927C',
				turquoise: '#69AE9A',
				steelBlue: '#94B8D2',
				lightBlue: '#E0EFFF',
			},
		},
		gray: {
			'05Percent': '#FAFAFA',
			'10Percent': '#F5F5F5',
			'20Percent': '#EEEEEE',
			'30Percent': '#E0E0E0',
			'40Percent': '#BDBDBD',
			'50Percent': '#9E9E9E',
			'54Percent': 'rgba(0, 0, 0, 0.54)',
			'60Percent': '#757575',
			'70Percent': '#616161',
			'80Percent': '#424242',
			'90Percent': '#212121',
			A10Percent: '#D5D5D5',
			A20Percent: '#AAAAAA',
			A40Percent: '#616161',
			A70Percent: '#303030',
		},
		light: {
			text: {
				primary: '#212121',
				secondary: '#565656',
				disabled: '#9E9E9E',
			},
			primary: {
				main: '#001453',
				dark: '#002D87',
				light: '#5780EB',
				contrast: '#FFFFFF',
				neutral: '#FAFAFA',
				'04Percent': '#F6FAFD',
				'06Percent': '#F7F5FC',
				'07Percent': '#F5F8FC',
				'08Percent': '#EDF4FC',
				'10Percent': '#E0EAF6',
				'12Percent': '#E3EEF9',
				'15Percent': '#E1EFFF',
				'20Percent': '#CCE3FF',
				'30Percent': '#BAD6F2',
				'50Percent': '#8BBAE8',
				'170Percent': '#003D85',
				'190Percent': '#004393',
			},
			secondary: {
				main: '#F5821F',
				dark: '#BC5400',
				light: '#FFB352',
				contrast: '#212121',
				'04Percent': '#FFFAF6',
				'08Percent': '#FFF5ED',
				'12Percent': '#FDF0E4',
				'30Percent': '#FCDABC',
				'50Percent': '#F9C08E',
			},
			error: {
				main: '#D32F2F',
				dark: '#C62828',
				light: '#EF5350',
				contrast: '#FFFFFF',
				'04Percent': '#FDF7F7',
				'12Percent': '#F9E6E6',
				'30Percent': '#F2C1C1',
				'50Percent': '#E89696',
				'160Percent': '#541313',
				'190Percent': '#FBEAEA',
			},
			warning: {
				main: '#FFA726',
				dark: '#C77800',
				light: '#FFD95B',
				contrast: '#212121',
				'04Percent': '#FFFCF7',
				'12Percent': '#FFF4E5',
				'30Percent': '#FFE5BE',
				'50Percent': '#FFD292',
				'160Percent': '#66430F',
				'190Percent': '#FFF6E9',
			},
			info: {
				main: '#4FC3F7',
				secondary: '#BCDBFF',
				dark: '#0093C4',
				light: '#8BF6FF',
				contrast: '#212121',
				'04Percent': '#F8FDFF',
				'12Percent': '#E9F7FE',
				'30Percent': '#CBEDFD',
				'35Percent': '#4FC3F74D',
				'50Percent': '#A6E0FA',
				'160Percent': '#204E63',
				'190Percent': '#EDF9FE',
			},
			success: {
				main: '#2E7D32',
				border: '#105434',
				dark: '#1B5E20',
				light: '#4CAF50',
				hue: '#71BA3C',
				contrast: '#FFFFFF',
				'04Percent': '#F7FAF7',
				'08Percent': '#E3F1EA',
				'12Percent': '#E6EFE6',
				'30Percent': '#C1D8C2',
				'50Percent': '#96BD98',
				'160Percent': '#123214',
				'190Percent': '#EAF2EA',
			},
			action: {
				active: '#757575',
				hover: '#F5F5F5',
				focus: '#E0E0E0',
				selected: '#EBEBEB',
				disabled: '#BDBDBD',
				disabledBackground: '#E0E0E0',
			},
			background: {
				paper: '#FFFFFF',
				'12Percent': 'rgba(255, 255, 255, 0.12)',
			},
			shadow: {
				elevation2: '0px 1px 8px 0 rgba(0, 0, 0, 0.15)',
			},
			other: {
				border: 'rgba(0, 0, 0, 0.12)',
				shadow: '#EDEFF2',
				divider: '#E0E0E0',
				scrollbar: '#00489e',
				scrollbarHover: '#013b7f',
				ratingActive: '#FFB400',
				outlineBorder: '#D6D6D6',
				backdropOverlay: '#7F7F7F',
				standartInputLine: '#B5B5B5',
				snackbarBackground: '#323232',
			},
		},
		dark: {
			text: {
				primary: '#FFFFFF',
				secondary: '#B9C3CE',
				disabled: '#8A9AAD',
			},
			primary: {
				main: '#94C5FF',
				dark: '#4AA2FF',
				light: '#C8F8FF',
				contrast: '#03070C',
				'08Percent': '#1F4269',
				'12Percent': '#23476F',
				'16Percent': '#294D75',
				'30Percent': '#3A638C',
				'50Percent': '#5280AA',
			},
			secondary: {
				main: '#FFA85C',
				dark: '#EF8928',
				light: '#FFDA8B',
				contrast: '#03070C',
				highlight: '#E66410',
				'08Percent': '#273F5C',
				'12Percent': '#31435C',
				'16Percent': '#3B485C',
				'30Percent': '#5B585D',
				'50Percent': '#8A6F5C',
			},
			error: {
				main: '#F44336',
				dark: '#D32F2F',
				light: '#E57373',
				contrast: '#FFFFFF',
				'08Percent': '#273759',
				'12Percent': '#2f3757',
				'30Percent': '#583A51',
				'50Percent': '#843C49',
				'160Percent': '#FBB4AF',
				'190Percent': '#190706',
			},
			warning: {
				main: '#FFA726',
				dark: '#C77800',
				light: '#FFD95B',
				contrast: '#03070C',
				'08Percent': '#273F58',
				'12Percent': '#314356',
				'30Percent': '#5B584C',
				'35Percent': '#FFA7264D',
				'50Percent': '#8A6E41',
				'160Percent': '#FFDCA8',
				'190Percent': '#1A1104',
			},
			info: {
				main: '#4FC3F7',
				dark: '#0093C4',
				light: '#8BF6FF',
				contrast: '#03070C',
				'08Percent': '#194269',
				'12Percent': '#1B466F',
				'30Percent': '#27608B',
				'50Percent': '#317CA9',
				'160Percent': '#B9E7FC',
				'190Percent': '#081419',
			},
			success: {
				main: '#66BB6A',
				dark: '#388E3C',
				border: '#105434',
				light: '#81C784',
				contrast: '#03070C',
				'08Percent': '#1B415D',
				'12Percent': '#1E455E',
				'30Percent': '#2E5E61',
				'50Percent': '#3D7863',
				'160Percent': '#C2E4C3',
				'190Percent': '#0A130B',
			},
			action: {
				active: '#98A7b7',
				hover: '#274669',
				focus: '#314E70',
				selected: '#3B5676',
				disabled: '#5B728D',
				disabledBackground: '#314E70',
			},
			background: {
				paper: '#203f63',
				paperElevation1: '#203F63',
				paperElevation2: '#244366',
				paperElevation3: '#274568',
				paperElevation4: '#29476A',
				paperElevation6: '#2E4B6D',
				paperElevation8: '#304D6F',
				paperElevation12: '#355172',
				paperElevation16: '#375374',
				paperElevation24: '#294F9A',
			},
			other: {
				divider: '#314E70',
				ratingActive: '#FFB400',
				outlineBorder: '#14355B',
				backdropOverlay: '#7F7F7F',
				standartInputLine: '#14355B',
				snackbarBackground: '#323232',
				stepperLabelDisabled: '#B9C3CE',
			},
		},
	},
	shape: {
		borderRadius: 8,
	},
	typography: {
		fontFamily: '"Figtree"',
		h1: {
			letterSpacing: -1.5,
		},
		h2: {
			letterSpacing: -0.5,
		},
		h3: {
			letterSpacing: 0,
		},
		h4: {
			letterSpacing: 0.25,
		},
		h5: {
			letterSpacing: 0,
		},
		h6: {
			letterSpacing: 0.15,
			fontWeight: 600,
		},
		subtitle1: {
			letterSpacing: 0.15,
		},
		subtitle2: {
			letterSpacing: 0.1,
			fontWeight: 600,
		},
		body1: {
			letterSpacing: 0.15,
		},
		body2: {
			letterSpacing: 0.15,
		},
		caption: {
			letterSpacing: 0.4,
		},
		overline: {
			letterSpacing: 1,
		},
		button: {
			textTransform: 'none',
			fontWeight: 600,
			letterSpacing: 0.46,
		},
	},
	brand: {
		primary: {
			blue: '#001453',
			white: '#FFFFFF',
			orange: '#F05A22',
			yellow: '#FDB713',
			lightOrange: '#F5821F',
			reddishOrange: '#EF402F',
			leadGray: '#3C3C3C',
		},
		secondary: {
			wheat: '#DED6C9',
			leadGray: '#3C3C3C',
			lightGray: '#585757',
			terracota: '#E8927C',
			turquoise: '#69AE9A',
			steelBlue: '#94B8D2',
		},
	},
	palette: {
		primary: {
			main: '#001453',
			contrastText: '#FFFFFF',
			dark: '#000F3D',
			light: '#5780EB',
			shades: {
				'4p': '#1976D20A',
				'12p': '#1976D21F',
				'30p': '#b8cceb',
				'50p': '#1976d2',
			},
			'800': '#1539AA',
			'900': '#142357',
		},
		secondary: {
			main: '#F5821F',
			contrastText: 'rgba(0,0,0,0.87)',
			dark: '#BC5400',
			light: '#FFB352',
			shades: {
				'30p': '#fddac1',
			},
		},
		success: {
			...originalTheme.palette.success,
			shades: {
				'12p': '#2E7D321F',
				'30p': '#c3d8c2',
				'160p': '#123214',
			},
		},
		error: {
			...originalTheme.palette.error,
			shades: {
				'4p': 'rgb(211, 47, 47)',
				'12p': '#fbe7e7',
			},
		},
		customInfo: {
			main: '#4FC3F7',
			contrastText: 'rgba(0,0,0,0.87)',
			dark: '#0093C4',
			light: '#8BF6FF',
			shades: {
				'30p': '#ceedfd',
				'160p': '#204e63',
			},
		},
		customWarning: {
			main: '#FFA726',
			contrastText: 'rgba(0,0,0,0.87)',
			dark: '#C77800',
			light: '#FFD95B',
			shades: {
				'30p': '#ffe5c3',
			},
		},
		text: {
			primary: '#212121',
			secondary: '#565656',
			error: '#AE1919',
		},
		other: {
			outlineBorder: 'rgba(0,0,0,0.23)',
			scrollbar: '#00489E',
			scrollbarHover: '#013B7F',
			progress: 'rgba(0, 0, 0, 0.35)',
			progressBar: '#94C5FF',
			closeIcon: 'rgba(255, 255, 255, 0.56)',
			inversedColorIconBg: '#EDF4FB',
			stepperLabelDisabled: '#B9C3CE',
			divider: 'rgba(0,0,0,0.12)',
			subtitle: '#495057',
			snackbarBackground: '#323232',
			planColor: '#001453',
			verticalBarColor: '#C7DEFF',
		},
	},

	components: {
		MuiCssBaseline: {},
		MuiAlertTitle: {
			styleOverrides: {
				root: {
					fontWeight: 600,
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					'&:has(+ div input[value=""]:-webkit-autofill:not(:focus))': {
						opacity: 0,
					},
				},
			},
		},
		MuiTypography: {
			variants: [
				{
					props: {variant: 'label'},
					style: ({theme}) => ({
						color: theme.palette.primary.main,
						fontWeight: 600,
						lineHeight: 1.75,
						letterSpacing: 0.15,
						marginBottom: 8,
						alignSelf: 'flex-start',
					}),
				},
				{
					props: {variant: 'subheader'},
					style: ({theme}) => ({
						color: theme.palette.text.secondary,
						fontWeight: 600,
						letterSpacing: 0.1,
						fontSize: '0.875rem',
						display: 'inline-block',
					}),
				},
				{
					props: {variant: 'alertTitle'},
					style: ({theme}) => ({
						color: theme.palette.primary.main,
						fontWeight: 600,
						lineHeight: 1.5,
						letterSpacing: 0.15,
						fontSize: '1rem',
						marginBottom: 10,
					}),
				},
				{
					props: {variant: 'helperText'},
					style: () => ({
						fontSize: '0.75rem',
						lineHeight: 1.6,
						letterSpacing: 0.4,
					}),
				},
			],
		},
		MuiMobileStepper: {
			defaultProps: {
				variant: 'progress',
				position: 'static',
			},
			styleOverrides: {
				root: ({theme}) => ({
					background: 'none',
					padding: 0,
					flex: 1,
					'& .MuiMobileStepper-progress': {
						width: '100%',
						background: theme.palette.other.progress,
						'& > .MuiLinearProgress-bar': {
							backgroundColor: theme.palette.other.progressBar,
						},
					},
				}),
			},
		},

		MuiButton: {
			variants: [
				{
					props: {variant: 'soft', color: 'success'},
					style: ({theme}) => ({
						backgroundColor: alpha(theme.palette.success.main, 0.12),
						color: theme.palette.success.main,
					}),
				},
			],
			defaultProps: {
				variant: 'contained',
				color: 'primary',
			},
			styleOverrides: {
				root: {
					borderRadius: 24,
					height: 'fit-content',
					whiteSpace: 'nowrap',
				},
				containedPrimary: ({theme}) => ({
					backgroundColor: theme.palette.primary.main,
					color: theme.palette.primary.contrastText,
					'&:hover': {
						backgroundColor: theme.palette.primary.dark,
					},
					'&.Mui-disabled': {
						backgroundColor: theme.palette.action.disabledBackground,
						color: theme.palette.text.disabled,
					},
				}),
				textPrimary: ({theme}) => ({
					color: theme.palette.primary.main,
				}),
				outlinedPrimary: ({theme}) => ({
					color: theme.palette.primary.main,
					borderColor: alpha(theme.palette.primary.main, 0.5),

					'&:hover': {
						borderColor: theme.palette.primary.main,
						backgroundColor: alpha(theme.palette.primary.main, 0.04),
					},
					'&.Mui-disabled': {
						color: theme.palette.text.disabled,
						borderColor: theme.palette.action.disabled,
						backgroundColor: 'transparent',
					},
				}),
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderRadius: 4,
				},
				notchedOutline: ({ownerState, theme}) => ({
					...(ownerState.disabled && {
						backgroundColor: theme.palette.action.disabledBackground,
						color: theme.palette.text.disabled,
						border: `1px dashed ${theme.palette.other.outlineBorder}`,
					}),
				}),
			},
		},
		MuiChip: {
			styleOverrides: {
				root: ({ownerState, theme}) => ({
					...(ownerState.variant === 'filled' &&
						ownerState.color !== 'default' &&
						ownerState.color !== undefined && {
							backgroundColor: theme.palette[ownerState.color]?.shades?.['30p'],
							color: theme.palette.text.primary,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'primary' && {
							backgroundColor: theme.palette.primary.shades?.['30p'],
							color: theme.palette.primary.dark,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'secondary' && {
							backgroundColor: theme.palette.secondary.shades?.['30p'],
							color: theme.palette.secondary.dark,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'warning' && {
							backgroundColor: theme.palette.customWarning.shades?.['30p'],
							color: theme.palette.customWarning.dark,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'info' && {
							backgroundColor: theme.palette.customInfo.shades?.['30p'],
							color: theme.palette.customInfo.dark,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'error' && {
							backgroundColor: theme.palette.error.shades?.['12p'],
							color: theme.palette.error.dark,
						}),
					...(ownerState.variant === 'filled' &&
						ownerState.color === 'success' && {
							backgroundColor: theme.palette.success.shades?.['30p'],
							color: theme.palette.success.dark,
						}),
					cursor: 'inherit',
				}),
				label: {
					paddingInline: 10,
				},
			},
		},
		MuiSkeleton: {
			styleOverrides: {
				root: ({ownerState}) => ({
					...(ownerState.variant === 'rectangular' && {
						borderRadius: 4,
					}),
				}),
			},
		},
		MuiAppBar: {
			defaultProps: {
				color: 'primary',
			},
			styleOverrides: {
				root: ({theme}) => ({
					backgroundColor: theme.palette.primary.main,
					color: theme.palette.primary.contrastText,
				}),
			},
		},
	},
};

const notredameSaudeTheme = createTheme(notredameSaudeStyles);

export {notredameSaudeStyles, notredameSaudeTheme};
